import { appInsights } from "us.helper";
import { CaseType } from "us.helper/types/enums";
import { ICaseSubCasesFrom } from "../Interfaces";
import { isSelectSameAdditionalReferenceCases } from "./IsSelectSameAdditionalReferenceCases";
import { isSelectedCasesInValidForCaseCreation } from "./IsSelectedCasesInValidForCaseCreation";


/**
 * @function
 * @description - Check for the desition to dissable the Create-case button
 * @param {ICaseSubCasesFrom} values - form values
 * @return {*}  {boolean} - boolean decision if the create case button is dissabled
 */
export const isCreateCaseButtonDisabled = (
  values: ICaseSubCasesFrom
): boolean => {
  try {
    const selectedCases = values.selectedCases ?? [];

    let isValidCreateCase = false;
    if (selectedCases.length > 1) {
      const hasAdditionalRefSelectedCases = selectedCases.some(
        (caseItem) =>
          caseItem.additionalReference1 || caseItem.additionalReference2
      );
      if (hasAdditionalRefSelectedCases) {
        isValidCreateCase = isSelectSameAdditionalReferenceCases(selectedCases);
      } else {
        isValidCreateCase = true;
      }
    }
    return isSelectedCasesInValidForCaseCreation(
      selectedCases,
      isValidCreateCase
    );
  } catch (error) {
    appInsights.trackException(
      `Cases and Subcases Home isCreateCaseButtonDisabled error - ${error}`
    );
    return true;
  }
};
